/**
 * 生態商城側欄 menuId（Overseas patch 168）
 * @see scripts/mysql/menu_tree_ssot/ecosystem_mall_group.json
 */
export const ECOSYSTEM_MALL_MENU_IDS = {
  group: 990420,
  topology: 990421,
  catalog: 990422,
  synergyEdges: 990423,
  intents: 990424,
  vendors: 990425,
  mediaBilling: 990426,
  productSpecs: 990427,
  productionLines: 990428,
  search: 990429,
  mediaHub: 990430,
  productKnowledge: 990434,
  trialSim: 990435,
  businessPlans: 990436,
  websitePages: 990437,
  virtualWorkspace: 990438,
  equipmentDemands: 990439,
  socOps: 991082,
  portraits: 991084,
  immersivePromo: 991086,
  adOrchestrate: 991091,
  channelCommand: 991139,
  bEndCrm: 991140,
  promoContent: 991097,
  companyPay: 991088,
  priceBook: 991094,
  billingPromo: 991115,
  commerceMatrix: 991112,
  mallPricingCollectFolder: 991123,
  appDownloads: 991136
}

export default ECOSYSTEM_MALL_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/ecosystemMall.js